import { AddOrEditAccountPage } from "./AddOrEditAccountPage";
export interface AccountPageProps {
    accountId: string;
}
export function AccountPage({ accountId }: AccountPageProps) {
    return <AddOrEditAccountPage createNew={false} accountId={accountId}/>;
}
